var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"svg-icon",class:_vm.bem('svg-icon', { icon: _vm.icon, color: _vm.color }),style:({ '--svg-icon--size': _vm.size })},[_c('use',{attrs:{"xlink:href":(_vm.source + "#" + _vm.icon)}})])}
var staticRenderFns = []

export { render, staticRenderFns }